export interface StockHistory {
  id: number;
  productID: number;
  optionValueID?: string;
  oldStock: number;
  newStock: number;
  createdAt: Date;
  createdBy: string;
  operationType: 'increment' | 'reduce';
  orderIdentifier?: string;
}

export const stockHistoryFromResponse = (responseData: any): StockHistory => ({
  id: responseData.id,
  productID: responseData.product_id,
  optionValueID: responseData.option_value_id,
  oldStock: responseData.old_stock,
  newStock: responseData.new_stock,
  createdAt: new Date(responseData.created_at),
  createdBy: responseData.created_by,
  operationType: responseData.operation_type,
  orderIdentifier: responseData.order_identifier,
});
